import apiClient from "./config";
import { CRYPTO_ENDPOINTS } from "./endpoints";

export const getTransationList = () => apiClient.get(CRYPTO_ENDPOINTS.GET_TRANSACTION_LIST);
export const getOrderList = () => apiClient.get(CRYPTO_ENDPOINTS.GET_ORDRER_LIST);

